import { render, staticRenderFns } from "./HeaderInformationNavigationBbg.vue?vue&type=template&id=6e9fcfa8"
import script from "./HeaderInformationNavigationBbg.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationBbg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports